function init_gamememory(from_php){
    if(typeof from_php.girl_id=="undefined" || from_php.girl_id==0){
        return false;
    }
    
    
    
    
    if(from_php.mode==1){
        init_gamememory_album(from_php);
        return false;
    }
    
    
    
    var toHide=$("#mainButtonsBar,#mainBeltRightDownCorner,#ic_premium");
    toHide.css("bottom","-100px")
    _moduleEvents.on("moduleClear",function(){
        toHide.removeAttr("style");
    });
    var semaphoreSuit= new mySemaphore();
    
    var girl_id=intval(from_php.girl_id);
    
    var timeIndexArr={
        "ajax":_moduleTimeHandler.getNewIndex(),
        "wrong":_moduleTimeHandler.getNewIndex(),
        "timeout":_moduleTimeHandler.getNewIndex(),
        "timeout_error":_moduleTimeHandler.getNewIndex()
    };
    
    var main=$(".place.gamememory");
    var confRemember=$.takeGirlConf(girl_id,"game_memory");
    var girl_name=$.takeGirlImage(girl_id);
    var ghostCanv;
    var load_image={},load_ghost={},number2image={};
    var animCanvas=main.find("#animMem");
    var gameCover=main.find("#gameCover");
    var gameCoverState=main.find(".stateJS"),gameCoverWin;
    var state_cur="";
    function prepareAll(){
        var order_arr=from_php.riddle_ord.split(",");
        if(order_arr.length==0){
            order_arr=[1,2,3,4,5,6,7,8,9,10];
        }
        var key,bum,color_arr=["green","red"],color,i;
        var start_url="/gfx/place/gamememory/girls/"+girl_name+"/parts",url;
        var val=1;
        
        confRemember['10']={left:45,top:209,width:88,height:90};
        confRemember['1']={left:45,top:638,width:88,height:90};
        confRemember['2']={left:1146,top:209,width:88,height:90};
        confRemember['3']={left:1146,top:316,width:88,height:90};
        confRemember['4']={left:1146,top:424,width:88,height:90};
        confRemember['5']={left:1146,top:531,width:88,height:90};
        confRemember['6']={left:1146,top:638,width:88,height:90};
        confRemember['7']={left:45,top:531,width:88,height:90};
        confRemember['8']={left:45,top:424,width:88,height:91};
        confRemember['9']={left:45,top:316,width:88,height:90};
        
        var confRememberCopy=copyObj(confRemember);
        var html={"cell":[],"item":[]},type;
        for(key in confRemember){
            type=""
            number2image[val]=key;
            confRemember[key].val=val;
            if(intval(key)==key){
                type="cell";
                key=intval(key);
                confRemember[key].left=confRememberCopy[order_arr[key-1]].left;
                confRemember[key].top=confRememberCopy[order_arr[key-1]].top;
            }
            if(key.toString().substr(0,4)=="item"){
                type="item";
            }
            bum=confRemember[key];
            url="";
            if(type=="item" || type=="cell"){
                if(type=="item"){
                    url=start_url+"/ready/"+key+".png";
                }
                else{
                    url="/gfx/place/gamememory/valen/game/"+key+".png";
                }
                
                html[type].push("<div class='iconView' style='left:"+bum.left+"px;top:"+bum.top+
                "px;width:"+bum.width+"px;height:"+bum.height+"px;"+
                "background-image:url("+url+")'></div>");
            }
            for(i in color_arr){
                color=color_arr[i];
                if(type=="cell"){
                    url="/gfx/place/gamememory/valen/game/"+color+".png";
                }
                else{
                    url=start_url+"/ready_"+color+"/"+key+".png";
                }
                load_image[(key+"_"+color)]=url;
            }
            load_ghost[key]={url:url,left:bum.left,top:bum.top};
            val++;
        }
        main.find("#gameMem").append(html["cell"]);
        main.find("#gameAllways").append(html["item"]);
        
        var girlObj=new girlSuitView(1003,{12:295});
        main.find(".girl.cupid").each(function(){
            girlObj.makeView($(this));
        });
        main.find("#gameAllways .eye").myEye({});
        
        
    }
    prepareAll();
    
    function postAjax(to_send,refuse_response,on_end){
        if(semaphoreSuit.use()){
            var data_send={girl_id:girl_id,page:"gamememory",wait:0};
            data_send=$.extend(data_send,to_send);
            $.mypost('/ajax',data_send, function(res) {
                var data=handleAjaxRes(res),was_clear=0;
                if(typeof data!="undefined" && data){
                    if(intval(data.was_ended)>intval(from_php.was_ended)){
                        _mySound.playSound("bravo");
                        $.goToLocation("girlownanim/"+girl_id+"/");
                        return false;
                    }
                    from_php=$.extend(from_php,data);
                    function isEnd(){
                        if(!refuse_response){
                            updateState();
                        }
                        if(typeof on_end=="function"){
                            on_end();
                        }
                    }
                    if(data_send.wait){
                        _moduleTimeHandler.setOne(timeIndexArr.ajax,function(){
                            isEnd();
                        },1500);
                    }
                    else{
                        isEnd();
                    }
                    
                }
                semaphoreSuit.clear();
            },"json");
        }
    }
    
    function updateState(){
        if(from_php.was_error){
            showState("wrong");
        }
        else if(from_php.mili_end==0){
            if(from_php.was_shown){
                postAjax({"start_game":1});
            }
            else{
                if(from_php.level==1){
                    if(from_php.try_count>0){
                        showState("init");
                    }
                    else{
                        showState("need_try");
                    }
                    
                }
                else{
                    showState("next");
                }
            }
        }
        else{
            var curTime=getCurrentTime();
            if(curTime*1000>from_php.mili_end){
                showState("timeout");
            }
            else{
                showState("game");
            }
            //timeout of game
            
        }
    }
    
    
    function init(){
        main.find(".butNextLevelJS").click(function(){
           _mySound.playSound("button_click");
            postAjax({"show_game":1},1,function(){
                if(from_php.was_paid){
                    showState("show_moves");
                }
                else{
                    showState("need_try");
                }
                
            });
            
        });
        main.find(".butNextLevelStartJS").click(function(){
            _mySound.playSound("button_click");
            showState("start");
        });
        main.find(".buyGirlDateJS").click(function(){
            _mySound.playSound("button_click");
            var th=$(this),premium_count=intval(th.attr("data-need"));
            $.payByPremium(premium_count,function(){
                postAjax({buy_date:1});
            });
        });
        main.find(".repeatMoveTriggerJS").click(function(){
            _mySound.playSound("button_click");
           var th=$(this),premium_count=intval(th.attr("data-need"));
           $.payByPremium(premium_count,function(){
                postAjax({buy_repeat:1});
                
            });
        });
        updateState();
    }
    function startGame(){
//        addText:function()
        animCanvas.startGirlAnim("addText",from_php.text_start,[640,390],"#00ff00",66,"#000000",10,5);
        _mySound.playSound("pvpgo_start");
        
        var time_end=Math.floor(from_php.mili_end/1000);
//        _timerManager.addTimer(".place.gamememory #gameTimerJS",time_end,1);
        
        //addTimer:function(selector,time_end,delete_on_module_load,funOnEnd)
        
        //from_php.mili_end
        var howlong_mili=(time_end-getCurrentTime())*1000;
        var mili_start=new Date().getTime();
        var mili_end=mili_start+howlong_mili;
        var timeObj=main.find("#gameTimerJS");
        _moduleTimeHandler.set(timeIndexArr.timeout,function(){
            var cur_mili=new Date().getTime();
            if(cur_mili>=mili_end){
                var step=0;
                _mySound.playSound("pvpfinish");
                _moduleTimeHandler.setOne(timeIndexArr.timeout_error,function(){
                    _mySound.playSound("pvpfinish");
                    _moduleTimeHandler.setOne(timeIndexArr.timeout_error,function(){
                        _mySound.playSound("pvpfinish");
                    },200);
                },200);
                
                
                
                showState("timeout");
                _moduleTimeHandler.clear(timeIndexArr.timeout);
                timeObj.html("0.00");
            }
            else{
                var remain_mili=mili_end-cur_mili;
                var sec=Math.floor(remain_mili/1000);
                var milisec=Math.floor((remain_mili-sec*1000)/10);
                if(milisec<10){
                    milisec="0"+milisec;
                }
                timeObj.html(sec+"."+milisec);
            }
            
            
        },40);
        
        main.find(".gameCountJS").html("0/"+from_php.need_sign);
        
        var moves_arr=[],riddle_arr=from_php.riddle_text.split(",");
        main.find("#gameGhost").off("click").click(function(e){
            var left=$.getXeventOffset(e),top=$.getYeventOffset(e);
            var click_name=ghostCanv.takeImage(left,top);
            if(click_name && state_cur=="game"){
                var qConf=confRemember[click_name];
                var pos=[qConf.left+qConf.width/2,qConf.top+qConf.height/2];
                var moves_len=moves_arr.length;
                moves_arr.push(qConf.val);
                var color;
                if(moves_arr[moves_len]==riddle_arr[moves_len]){
                    //good
                    color="green";
                    main.find(".gameCountJS").html(moves_arr.length+"/"+from_php.need_sign);
                    if(moves_len+1==from_php.need_sign){
                        //good
                        main.find("#gameGhost").off("click");
                        _moduleTimeHandler.clear(timeIndexArr.timeout);
                        var i,conf=1;
                        for(i in moves_arr){
                            if(i>0){
                                conf+=Math.pow(moves_arr[i]+moves_arr[i-1],2)
                            }
                            else{
                                conf+=moves_arr[i];
                            }
                        }
                        animCanvas.startGirlAnim("addText",from_php.text_scored,[640,390],"#00ff00",66,"#000000",30,5);
                        postAjax({game_conf:conf,wait:1});
                    }
                    _mySound.playSound("button_click");
                }
                else{
                    main.find("#gameGhost").off("click")
                    _moduleTimeHandler.clear(timeIndexArr.timeout);
                    var correct_id=riddle_arr[moves_len];
                    var qConfCorrect=confRemember[number2image[correct_id]];
                    
                    var pos2=[qConfCorrect.left+qConfCorrect.width/2,qConfCorrect.top+qConfCorrect.height/2];
                    _moduleTimeHandler.addOne(function(){
                        animCanvas.startGirlAnim("addAnimCustom",pos2,pos2,number2image[correct_id]+"_green",20,[100,100],[100,20]);
                    },500);
                    
                    //WRONG
                    color="red";
                    _moduleTimeHandler.setOne(timeIndexArr.wrong,function(){
                        showState("wrong");
                    },1500);
                    
                    postAjax({game_conf:1,wait:1},1);
                    _mySound.playSound("pvpfinish");
                }
                animCanvas.startGirlAnim("addAnimCustom",pos,pos,click_name+"_"+color,20,[100,100],[100,20]);
                
            }
            return false;
        });
    }
    
    
    var stateIndex={
        "show_moves":[_moduleTimeHandler.getNewIndex(),_moduleTimeHandler.getNewIndex()],
        "game":[_moduleTimeHandler.getNewIndex()]
    };
    var stateFun={
        "show_moves":function(){
            if(from_php.was_shown){
                return false;
            }
            main.find(".beltMin.stateJS").removeClass("hide");
            
            var interval_arr=[25,60],i;
            function prepareQueue(sign,inverval_count){
                _moduleTimeHandler.queueAdd(stateIndex.show_moves[0],function(){
                    var click_name=number2image[sign];
                    var qConf=confRemember[click_name];
                    var pos=[qConf.left+qConf.width/2,qConf.top+qConf.height/2];
                    animCanvas.startGirlAnim("addAnimCustom",pos,pos,click_name+"_green",inverval_count,[100,100],[100,20]);
                    _moduleTimeHandler.setOne(stateIndex.show_moves[1],function(){
                        _moduleTimeHandler.queueTrigger(stateIndex.show_moves[0]);
                    },inverval_count*40);
                });
            }
            var riddle_arr=from_php.riddle_text.split(",");
            for(i=0;i<from_php.need_sign_before;i++){
                prepareQueue(riddle_arr[i],interval_arr[0]);
            }
            inverval_count=interval_arr[1];
            for(i=from_php.need_sign_before;i<from_php.need_sign;i++){
                prepareQueue(riddle_arr[i],interval_arr[1]);
            }
            _moduleTimeHandler.queueAdd(stateIndex.show_moves[0],function(){
                postAjax({"start_game":1});
            });
            
             _moduleTimeHandler.setOne(stateIndex.show_moves[1],function(){
                _moduleTimeHandler.queueTrigger(stateIndex.show_moves[0]);
            },interval_arr[0]*40);
            
            
            
            return true;
            
        },
        "wrong":function(){
            if(from_php.level>3){
                main.find(".repeatMoveJS").show();
            }
            else{
                main.find(".repeatMoveJS").hide();
            }
        },
        "timeout":function(){
            if(from_php.level>3){
                main.find(".repeatMoveJS").show();
            }
            else{
                main.find(".repeatMoveJS").hide();
            }
        },
        "init":function(){
            
        },
        "start":function(){
            main.find(".beltMin.stateJS").removeClass("hide");
            main.find("#gameTimerJS").html(from_php.text_get_ready);
            main.find(".gameCountJS").html("0/"+from_php.need_sign);
        },
        "need_try":function(){
            
        },
        "next":function(){
            main.find(".putGameJs[data-type='level']").html(from_php.level);
        },
    };
    function showState(state){
        main.find(".putGameJs[data-type='try']").html(from_php.try_count);
        main.find(".arrSetCountJS").attr("data-count",from_php.try_count);
        _timerManager.addTimer(".place.gamememory .timerKeyWaitJS",from_php.try_time,1);
        _moduleTimeHandler.clear(timeIndexArr.timeout);
        
        
        state_cur=state;
        var gameMem=main.find("#gameMem");
        if(state=="game" || state=="show_moves" || state=="start"){
            gameMem.removeClass("hide");
        }
        else{
            gameMem.addClass("hide");
        }
        
        gameCoverWin=gameCoverState.addClass("hide").filter("[data-state='"+state+"']").removeClass("hide");
        if(state=="game"){
            gameCover.addClass("hide");
            startGame();
        }
        else{
            gameCover.removeClass("hide");
            if(typeof stateFun[state]=="undefined"){
                alert(state+"!");
            }
            stateFun[state]();
        }
    }
    
    
    animCanvas.one("was_loaded",function(){
        ghostCanv=new myGhostClick([1280,780],load_ghost,function(){
            init();
        });
//        animCanvas.startGirlAnim("addAnimCustom",[110,110],[110,110],"head_green",100);
    }).startGirlAnim({
        load_images:load_image,
        width:390,
        height:700
    },_moduleTimeHandler);
    
    
    main.find(".book[g_id='1']").on("close",function(){
        main.find("#gameCover").removeClass("bookHide");
    }).on("open",function(){
       main.find("#gameCover").addClass("bookHide");
    });
    
}